// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"916faf3b","534":"820ac831"}[chunkId] + ".chunk.js";
};